import React, {useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, FormGroup, TextField} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import {Alert} from "@mui/lab";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import shadowClient from "../lib/clients/shadow/shadowClient";
import Box from "../Common/Box";
import ControlButton from "../Common/ControlButton";
import ContentCopyOutlined from "@mui/icons-material/ContentCopyOutlined";
import utils, {createInviteLink} from "../lib/utils";
import {notifier} from "../lib/Notifier";
import {RoomTypes} from "../lib/clients/shadow/interfaces";
import Button from "@mui/material/Button";
import LockReset from "@mui/icons-material/LockReset";
import {observer} from "mobx-react";

const RoomSettings = ({open, onClose}: {
    open: boolean,
    onClose: () => any
}) => {

    const [error, setError] = useState("");

    const handleClose = () => {
        onClose();
        setError("");
    }

    const room = shadowClient.getJoinedRoom();

    if (!room) {
        return null;
    }

    const isPublic = room.type === RoomTypes.PUBLIC;
    const inviteToken = room.invite_tokens[0];

    let inviteLink: string | undefined;

    if (inviteToken) {
        inviteLink = createInviteLink(undefined, undefined, inviteToken);
    }

    return <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Room settings</DialogTitle>
        <DialogContent>
            <DialogContentText>
                To only allow people with invites please disable the public room toggle
            </DialogContentText>
            <FormGroup>
                <FormControlLabel
                        control={
                            <Switch
                                    checked={isPublic}
                                    onChange={async (event, isPublic) => {
                                        const newType = isPublic ? RoomTypes.PUBLIC : RoomTypes.PRIVATE;
                                        await shadowClient.patchRoom(room.id, {type: newType}).catch(e => setError(e.message));
                                    }}
                            />
                        }
                        label="Make room public"
                />
            </FormGroup>
            {!isPublic && inviteLink && <Box row alignItems={"center"}>
                <TextField
                        disabled
                        sx={{marginRight: "10px"}}
                        inputProps={
                            {readOnly: true}
                        }
                        margin="dense"
                        label="Invite link"
                        fullWidth
                        variant="standard"
                        value={inviteLink}
                />

                <ControlButton
                        label={"Copy invite link"}
                        icon={ContentCopyOutlined}
                        onClick={() => {
                            utils.copyToClipboard(inviteLink).then(() => {
                                notifier.info("Copied your invite link");
                            }).catch(e => setError(e.message));
                        }}
                />

            </Box>
            }


        </DialogContent>

        {error && <Alert
                sx={{
                    margin: "-10px 20px 4px",
                }}

                variant="outlined"
                severity="error"
        >
            {error}
        </Alert>}

        <DialogActions
                sx={{
                    justifyContent: "flex-end",
                    padding: "10px",
                }}
        >
            {!isPublic && <Button
                    size="small"
                    variant={"outlined"}
                    component="label"
                    startIcon={<LockReset/>}
                    onClick={() => {
                        shadowClient.resetInviteToken(room.id).then(inviteToken => {
                            room.invite_tokens.length = 0;
                            room.invite_tokens.push(inviteToken);
                            // shadowClient.roomStore.upsertRoom({id: room.id, room.});
                        }).catch(error => setError(error?.message || "unknown error while resetting invite token"));
                    }}>
                Reset invite
            </Button>}

            <Button
                    size="small"
                    variant={"text"}
                    onClick={handleClose}>
                Close
            </Button>

        </DialogActions>
    </Dialog>
};

export default observer(RoomSettings);
